import { createRoot } from 'react-dom/client';
import NonAuthenticatedApp from './non-authenticated-app/App';

export const renderNonAuthenticatedApp = () => {
    const domNode = document.getElementById('root');
    const root = createRoot(domNode);

    root.render(<NonAuthenticatedApp />);
};
